import { render } from "./MyBooking.vue?vue&type=template&id=1d88dd45"
import script from "./MyBooking.vue?vue&type=script&lang=js"
export * from "./MyBooking.vue?vue&type=script&lang=js"

import "./MyBooking.vue?vue&type=style&index=0&id=1d88dd45&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__